export class Lote {
    public cdlote: number;
    public descricao: string;
    public cdfazenda: number;
  }
